module.exports = __webpack_public_path__ + "static/media/error-404.30b7d264.png";